import { render, staticRenderFns } from "./AddFriendBtn.vue?vue&type=template&id=40a23404&scoped=true&"
import script from "./AddFriendBtn.vue?vue&type=script&lang=js&"
export * from "./AddFriendBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddFriendBtn.vue?vue&type=style&index=0&id=40a23404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a23404",
  null
  
)

export default component.exports